import * as React from "react";

export const Malo = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <rect
      width={22}
      height={22}
      x={1}
      y={1}
      rx={7.656}
      style={{
        fill: "#f8de40",
      }}
    />
    <path
      d="M23 13.938a14.69 14.69 0 0 1-12.406 6.531c-5.542 0-6.563-1-9.142-2.529A7.66 7.66 0 0 0 8.656 23h6.688A7.656 7.656 0 0 0 23 15.344z"
      style={{
        fill: "#e7c930",
      }}
    />
    <path
      d="M7.055 7.313A1.747 1.747 0 1 0 8.8 9.059a1.747 1.747 0 0 0-1.745-1.746zm9.903 0A1.747 1.747 0 1 0 18.7 9.059a1.747 1.747 0 0 0-1.742-1.746zM14 13.937a.318.318 0 0 1-.313-.326 2.105 2.105 0 0 0-.5-1.331A1.6 1.6 0 0 0 12 11.847a1.6 1.6 0 0 0-1.187.43 2.092 2.092 0 0 0-.5 1.335.32.32 0 0 1-.64.012 2.715 2.715 0 0 1 .679-1.792A2.211 2.211 0 0 1 12 11.207a2.211 2.211 0 0 1 1.647.625 2.721 2.721 0 0 1 .679 1.792.321.321 0 0 1-.326.313z"
      style={{
        fill: "#864e20",
      }}
    />
  </svg>
);